.container {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 13px;
  flex-wrap: wrap;
  padding: 2px 0px;
  min-width: 30px;
}

.container-warning .value {
  background-color: var(--pill-warning-background);
  border-radius: 50%;
  width: 20px;
  height: 20px;
  text-align: center;
}

.container-danger .value {
  background-color: var(--pill-danger-background);
  border-radius: 50%;
  width: 20px;
  height: 20px;
  text-align: center;
}

.label,
.container-danger .label,
.container-warning .label {
  color: var(--main-text);
}

.link {
  color: var(--badge-color);
  cursor: pointer;
  font-weight: 600;
}

.value {
  font-weight: 600;
}

.container .icon {
  font-size: 16px;
  color: var(--muted-icon-color);
}

.tooltip {
  cursor: pointer;
}
.external-link {
  display: flex;
  align-items: center;
  gap: 3px;
}
.external-link .icon {
  color: inherit;
}
